/**
 * Visual Discovery Service
 * Handles image-based music discovery API calls
 */

import { post } from '../lib/api-client';
import type { VisualDiscoveryResponse } from '../types/visual.types';

/**
 * Generate music recommendations from uploaded images
 */
export async function generateVisualDiscovery(
  images: File[],
  searchDepth: 'quick' | 'balanced' | 'deep' = 'balanced'
): Promise<VisualDiscoveryResponse> {
  // Build FormData with images
  const formData = new FormData();
  images.forEach(file => {
    formData.append('images', file);
  });
  formData.append('search_depth', searchDepth);

  // Make request with FormData
  // The axios client will automatically set Content-Type: multipart/form-data
  const response = await post<VisualDiscoveryResponse>('/visual/discover', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  if (!response.success || !response.data) {
    throw new Error(response.error?.message || 'Failed to generate visual recommendations');
  }

  return response.data;
}
